import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ActivityItem } from '../../clients/activities/model';
import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';
import ActivityStore from '../../store/activityStore';
import FeatureFlagsStore from '../../store/featureFlagsStore';
import GroupedList from '../GroupedList';

import EmptyYourWorkTab from './EmptyYourWorkTab';
import eventTypeMessages from './eventTypeMessages';
import YourWorkRow from './YourWorkRow';

const WorkedOnContent = styled.div`
  width: 100%;
  flex-grow: 1;
`;

interface Props {
  activityStore: ActivityStore;
  featureFlagsStore: FeatureFlagsStore;
}

function listStats(items: ActivityItem[]): object {
  return {
    itemCount: items.length,
  };
}

@observer
class WorkedOn extends React.Component<Props & AnalyticsConsumerProps> {
  componentDidMount() {
    void this.props.analytics.track('tabWorkedOn', 'viewed', {
      ...listStats(this.props.activityStore.works),
    });
  }

  render() {
    const { works } = this.props.activityStore;
    if (works.length === 0) {
      return <EmptyYourWorkTab />;
    }
    return (
      <WorkedOnContent>
        <GroupedList
          data={works}
          renderItem={work => {
            return (
              <YourWorkRow
                key={work.object.id}
                analyticsAttributes={{
                  eventType: work.eventType,
                  tab: 'workedOn',
                }}
                object={work.object}
                contributors={work.contributors}
                container={work.container}
                fullIndex={work.fullIndex}
              >
                <FormattedMessage {...eventTypeMessages[work.eventType]} />
              </YourWorkRow>
            );
          }}
        />
      </WorkedOnContent>
    );
  }
}

export default inject(({ activityStore, featureFlagsStore }) => ({ activityStore, featureFlagsStore }))(
  withAnalytics(WorkedOn),
);
